export const CART_LOADING = 'cart/CART_LOADING';
export const CART_UPDATING = 'cart/CART_UPDATING';
export const CART_LOAD = 'cart/CART_LOAD';
export const CART_RESET = 'cart/CART_RESET';
